import { z } from "@/zod";

export const readContractorPlannedHours = z
  .object({
    id: z.string(),
    period: z.string(),
    planned_hours: z.number(),
  })
  .readonly();

export const contractorPanelPlannedHoursStatus = z
  .object({
    should_show_planned_hours: z.boolean(),
    accepted_at: z.string().datetime().optional(),
  })
  .readonly();

export const contractorPanelPlannedHoursAccept = z
  .object({
    period: z.string(),
    planned_hours: z.string(),
  })
  .readonly();
